import request from '@/utils/request';



// 添加团队
export function teamAdd(data) {
  return request({
    url: 'team/add',
    method: 'post',
    data
  })
}


// 查询团队
export function teamList(params) {
    return request({
      url: 'team/list',
      method: 'get',
      params
    })
  }


  // 修改u团队
export function teamModify(data) {
    return request({ 
      url: 'team/modify',
      method: 'post',
      data
    })
  }

  // 删除团队
export function teamRemove(data) {
  return request({
    url: 'team/remove',
    method: 'post',
    data
  })
}


  // 删除团队
  export function addTeamAdmin(data) {
    return request({
      url: 'team/add/teamAdmin',
      method: 'post',
      data
    })
  }

  //分页获取团队账号
  export function listAdmin(params) {
    return request({
      url: 'team/list/admin',
      method: 'get',
      params
    })
  }


// WEBPACK FOOTER //
// ./src/api/temp.js